import Report from 'garaje/models/report';
import _defaults from 'lodash/defaults';

export default class EmployeeScreening extends Report {
  declare reason: string | null;

  constructor(attrs: Partial<EmployeeScreening> = {}) {
    super(attrs);
    const props = { ...attrs };
    _defaults(props, {
      reason: null,
    });
    Object.assign(this, props);
  }
}
